import { inspectReloadableGiftingTokenQuery } from 'graphql/gift';
import { useState, useEffect } from 'react';

import { client as api2Client } from 'util/api2Client';

const useReloadableGiftingToken = ({ token, noGift = false }) => {
  const [reloadableToken, setReloadableToken] = useState();
  const [loading, setLoading] = useState(true);

  const fetchReloadableToken = async () => {
    if (!token) return;

    const variables = {
      token,
      noGift,
    };

    const options = {
      variables,
      query: inspectReloadableGiftingTokenQuery,
      fetchPolicy: 'no-cache',
      errorPolicy: global.IS_LOCAL_OR_DEV ? 'all' : 'none',
    };

    try {
      const result = await api2Client.query(options);
      setReloadableToken(result.data.getReloadableGiftingToken);
    } catch (err) {
      if (global.IS_LOCAL_OR_DEV) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchReloadableToken().finally(() => {
      setLoading(false);
    });
  }, [token]);

  return {
    reloadableToken,
    loading,
  };
};

export default useReloadableGiftingToken;
